/**
 * Absolute links containing `://`.
 */
export const ABSOLUTE_URL = /^(?:[a-z]+:)?\/\//;

/**
 * Lesson links are considered to be links starting with `/lesson`.
 */
export const LESSON_LINK_RE = /^\/lesson\/([^/]+)\/?$/;
